import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5756e04d&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5756e04d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\a-项目\\付好佳\\多用户商城平台端\\fhj-web-dyh-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5756e04d')) {
      api.createRecord('5756e04d', component.options)
    } else {
      api.reload('5756e04d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5756e04d&scoped=true", function () {
      api.rerender('5756e04d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/label/index.vue"
export default component.exports